module.exports = __webpack_public_path__ + "img/borderTriangleWhite.35a7b690.svg";